import { getList, getOne } from './getData'
import { setCreate, setUpdate, setDelete } from './setData'

const advertising = {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    idSelected: '',
    Selected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.list = list || []
    },
    updateOne: (state, one) => {
      state.Selected = one
      state.idSelected = one ? one._id : ''
    },
    updateLoading: (state, loading) => state.loading = loading,
    updateClearOne: (state) => {
      state.Selected = {}
      state.idSelected = ''
    }
  },
  actions: {
    setInit: async ({ commit }, params) => await getList(params, commit),
    setNew: async ({ commit }, ads) => {
      await setCreate(ads)
      getList(commit)
    },
    setUpdate: async ({ commit }, ads) => {
      await setUpdate(ads)
      getList(commit)
    },
    setEliminate: async ({ commit }, id) => {
      await setDelete(id)
      getList(commit)
    },
    setOne: async ({ commit }, id) => {
      await getOne(commit, id)
    },
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    }
  }
}

export default advertising
